import { css } from '@emotion/css';
import step1 from '@volumental/assets/images/Hybrid/introMap1.png';
import step2 from '@volumental/assets/images/Hybrid/introMap2.png';
import { Button, Content, Headline, TextButton } from '@volumental/common';
import { type JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Header } from '../../components/accessible-components';
import { JourneyListItem } from '../onboarding/components/journey-list-item';
import { PrivacyFooter } from './privacy-footer';

const buttonContainer = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 140px;
  margin-top: 30px;
`;

const contentStyle = css`
  padding: 0px 24px;
`;

const itemContainerStyle = css`
  width: 100%;
  display: flex;
  justify-items: center;
  justify-self: center;
  align-self: center;
  justify-content: left;
  padding: 7px 0px;
`;

interface StepListIntroProps {
  onClose: () => void;
  onClick: () => void;
  onAlternative?: () => void;
  showAlternative: boolean;
  mainBtTitle: string;
  alternativeBtTitle: string;
}
export function StepListIntro({
  onClose,
  onClick,
  onAlternative,
  showAlternative,
  mainBtTitle,
  alternativeBtTitle,
}: StepListIntroProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <>
      <Header close={onClose} />
      <Content disableGutters disableScrollbar>
        <div className={contentStyle}>
          <Headline style={{ textAlign: 'left', margin: '2rem 0' }}>
            {t('hybrid.journeyMap.title')}
          </Headline>
          <div className={itemContainerStyle}>
            <JourneyListItem
              item={{
                alt: t('hybrid.journeyMap.step1.alt'),
                imgSrc: step1,
                title: t('hybrid.journeyMap.step1.title'),
                description: t('hybrid.journeyMap.step1.description'),
              }}
            />
          </div>
          <div className={itemContainerStyle}>
            <JourneyListItem
              item={{
                alt: t('hybrid.journeyMap.step2.alt'),
                imgSrc: step2,
                title: t('hybrid.journeyMap.step2.title'),
                description: t('hybrid.journeyMap.step2.description'),
              }}
            />
          </div>
          <div className={buttonContainer}>
            <Button loading={false} type="submit" onClick={onClick}>
              {mainBtTitle}
            </Button>
            {showAlternative && (
              <TextButton onClick={onAlternative}>
                {alternativeBtTitle}
              </TextButton>
            )}
          </div>
        </div>
      </Content>
      <PrivacyFooter />
    </>
  );
}
